import { getAllData } from 'apis/customApiHandler';
import AddTrainingMateraial from '../components/training-materials/addTrainingMaterial';
import ViewTrainingMaterialList from '../components/training-materials/viewTrainingMaterial';
import useDebounce from 'hooks/useDebounce';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { Button, Input, Select } from 'styled';
import { TH } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';

const TrainingMaterial = () => {
  const [showAddmodel, setShowAddmodel] = useState(false);
  const [search, setSearch] = useState('');
  const [active, setActive] = useState("")
  const currentUser = useSelector((state) => state.user.currentUser);
  const debouncedValue = useDebounce(search, 1000);
  const { data: trainingMaterials } = useQuery(
    ['training-materials', debouncedValue && debouncedValue, active],
    () => getAllData('/training-material', { searchQuery: debouncedValue, active: active === "" ? "all" : active })
  );

  return (
    <div>
      <div className="m-10">
        <div className="mt-8 flex justify-start gap-6 items-end flex-wrap lg:flex-nowrap">
          <div className="relative w-full">
          <label className="w-full py-3 flex flex-col gap-2">
            Search by Name
            <Input
              type="search"
              placeholder="Search Here"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
            </label>
          </div>
          <div className="w-full max-w-[14rem]">
          <label className="w-full py-3 flex flex-col gap-2">
            Active
            <Select
              name="active"
              value={active}
              onChange={(e) => setActive(e.target.value)}
            >
              <option value={""}>All</option>
              <option value={true}>Active</option>
              <option value={false}>Inactive</option>
            </Select>
          </label>
          </div>
          <Button
            className="mb-3 !px-8 disabled:bg-gray-400"
            bgPrimary
            onClick={() => setShowAddmodel(true)}
            disabled={
              !checkPermission([permissions.create_training_material], currentUser)
            }
          >
            Add
          </Button>
        </div>
      </div>
      <div className="flex flex-col m-2 lg:m-10">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <TH scope="col">S.N.</TH>
                    <TH scope="col">Name of the Training Material</TH>
                    <TH scope="col">Added By</TH>
                    <TH scope="col">Created At</TH>
                    <TH scope="col">Type</TH>
                    <TH scope="col">Active</TH>
                    <TH scope="col">Actions</TH>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {trainingMaterials?.data &&
                    trainingMaterials?.data.map((document, index) => (
                      <ViewTrainingMaterialList
                        document={document}
                        key={document._id}
                        index={index}
                      />
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {showAddmodel && (
        <AddTrainingMateraial handleClick={() => setShowAddmodel(false)} />
      )}
    </div>
  );
};

export default TrainingMaterial;
